import _classCallCheck from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { Vec3 } from '../math/Vec3.js';
import { Quat } from '../math/Quat.js';
import { Mat4 } from '../math/Mat4.js';
import { Euler } from '../math/Euler.js';
export var Transform = /*#__PURE__*/function () {
  function Transform() {
    var _this = this;

    _classCallCheck(this, Transform);

    this.parent = null;
    this.children = [];
    this.visible = true;
    this.matrix = new Mat4();
    this.worldMatrix = new Mat4();
    this.matrixAutoUpdate = true;
    this.position = new Vec3();
    this.quaternion = new Quat();
    this.scale = new Vec3(1);
    this.rotation = new Euler();
    this.up = new Vec3(0, 1, 0);

    this.rotation.onChange = function () {
      return _this.quaternion.fromEuler(_this.rotation);
    };

    this.quaternion.onChange = function () {
      return _this.rotation.fromQuaternion(_this.quaternion);
    };
  }

  _createClass(Transform, [{
    key: "setParent",
    value: function setParent(parent) {
      var notifyParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (notifyParent && this.parent && parent !== this.parent) this.parent.removeChild(this, false);
      this.parent = parent;
      if (notifyParent && parent) parent.addChild(this, false);
    }
  }, {
    key: "addChild",
    value: function addChild(child) {
      var notifyChild = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!~this.children.indexOf(child)) this.children.push(child);
      if (notifyChild) child.setParent(this, false);
    }
  }, {
    key: "removeChild",
    value: function removeChild(child) {
      var notifyChild = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!!~this.children.indexOf(child)) this.children.splice(this.children.indexOf(child), 1);
      if (notifyChild) child.setParent(null, false);
    }
  }, {
    key: "updateMatrixWorld",
    value: function updateMatrixWorld(force) {
      if (this.matrixAutoUpdate) this.updateMatrix();

      if (this.worldMatrixNeedsUpdate || force) {
        if (this.parent === null) this.worldMatrix.copy(this.matrix);else this.worldMatrix.multiply(this.parent.worldMatrix, this.matrix);
        this.worldMatrixNeedsUpdate = false;
        force = true;
      }

      for (var i = 0, l = this.children.length; i < l; i++) {
        this.children[i].updateMatrixWorld(force);
      }
    }
  }, {
    key: "updateMatrix",
    value: function updateMatrix() {
      this.matrix.compose(this.quaternion, this.position, this.scale);
      this.worldMatrixNeedsUpdate = true;
    }
  }, {
    key: "traverse",
    value: function traverse(callback) {
      // Return true in callback to stop traversing children
      if (callback(this)) return;

      for (var i = 0, l = this.children.length; i < l; i++) {
        this.children[i].traverse(callback);
      }
    }
  }, {
    key: "decompose",
    value: function decompose() {
      this.matrix.getTranslation(this.position);
      this.matrix.getRotation(this.quaternion);
      this.matrix.getScaling(this.scale);
      this.rotation.fromQuaternion(this.quaternion);
    }
  }, {
    key: "lookAt",
    value: function lookAt(target) {
      var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (invert) this.matrix.lookAt(this.position, target, this.up);else this.matrix.lookAt(target, this.position, this.up);
      this.matrix.getRotation(this.quaternion);
      this.rotation.fromQuaternion(this.quaternion);
    }
  }]);

  return Transform;
}();